import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { FreeSpaceJudgeDetailModuleName } from '@/store/modules/modules'

export class FreeSpaceJudgeDetailViewModel {
  private store = useStore()

  judgeDetail: ComputedRef<JudgeDetail> = computed(
    () => this.store.getters[`${FreeSpaceJudgeDetailModuleName}/judgeDetail`]
  )
}
